export const departmentTypes = {
  TAXES: 'taxes',
  TICKETS: 'tickets'
};
